import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function MobileNavigation({ dark = false, onConsultation }) {
  const [isOpen, setIsOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState("");

  const closeDrawer = () => {
    setIsOpen(false);
    setOpenGroup("");
  };

  useEffect(() => {
    document.body.classList.toggle("mobile-drawer-open", isOpen);
    return () => document.body.classList.remove("mobile-drawer-open");
  }, [isOpen]);

  const toggleGroup = (group) => {
    setOpenGroup((current) => (current === group ? "" : group));
  };

  const handleConsultation = () => {
    closeDrawer();
    onConsultation();
  };

  return (
    <div className={`mobile-navigation ${dark ? "mobile-navigation-dark" : ""}`}>
      <button
        type="button"
        className="mobile-menu-toggle"
        onClick={() => setIsOpen(true)}
        aria-label="Open navigation menu"
        aria-expanded={isOpen}
      >
        <span />
        <span />
        <span />
      </button>

      <button
        type="button"
        className={`mobile-drawer-backdrop ${isOpen ? "open" : ""}`}
        onClick={closeDrawer}
        aria-label="Close navigation menu"
        tabIndex={isOpen ? 0 : -1}
      />

      <aside
        className={`mobile-menu-drawer ${isOpen ? "open" : ""}`}
        aria-hidden={!isOpen}
      >
        <div className="mobile-drawer-header">
          <Link to="/" onClick={closeDrawer}>
            <img src="/assets/images/dark-logo.png" alt="Catalyze" />
          </Link>
          <button
            type="button"
            className="mobile-drawer-close"
            onClick={closeDrawer}
            aria-label="Close navigation menu"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        <nav className="mobile-drawer-nav" aria-label="Mobile navigation">
          <div className={`mobile-drawer-group ${openGroup === "about" ? "open" : ""}`}>
            <button type="button" onClick={() => toggleGroup("about")}>
              <span>About</span>
              <i className="fa-solid fa-chevron-down" />
            </button>
            <div className="mobile-drawer-submenu">
              <Link to="/about-us" onClick={closeDrawer}>Catalyze</Link>
              <Link to="/founder" onClick={closeDrawer}>Founder</Link>
            </div>
          </div>

          <div className={`mobile-drawer-group ${openGroup === "programs" ? "open" : ""}`}>
            <button type="button" onClick={() => toggleGroup("programs")}>
              <span>Programs</span>
              <i className="fa-solid fa-chevron-down" />
            </button>
            <div className="mobile-drawer-submenu">
              <Link to="/programs" onClick={closeDrawer}>Our Programs</Link>
              <Link to="/institution" onClick={closeDrawer}>Institution</Link>
            </div>
          </div>

          <div className={`mobile-drawer-group ${openGroup === "teambuilding" ? "open" : ""}`}>
            <button type="button" onClick={() => toggleGroup("teambuilding")}>
              <span>Team Building</span>
              <i className="fa-solid fa-chevron-down" />
            </button>
            <div className="mobile-drawer-submenu">
              <Link to="/corporate-team-building" onClick={closeDrawer}>Corporate Team Building</Link>
              <Link to="/campus-team-building" onClick={closeDrawer}>Campus Team Building</Link>
            </div>
          </div>

          <Link className="mobile-drawer-link" to="/blogs" onClick={closeDrawer}>
            Blogs
          </Link>
          <Link className="mobile-drawer-link" to="/contact" onClick={closeDrawer}>
            Contact
          </Link>
        </nav>

        <button
          type="button"
          className="default-btn mobile-drawer-cta"
          onClick={handleConsultation}
        >
          Book a Consultation
        </button>
      </aside>
    </div>
  );
}
